import { CopyData } from "../../../../../../../../components/ui/CopyData/CopyData";
import "./IpData.scss";

export const IpData = ({ title, value }) => (
    <div className="ip-data">
      <CopyData data={value} />
      {title}: <span>{value}</span>
    </div>
  );
